import React, { useState } from "react";
import Header from "./Header";
import Footer from "./Footer";

export default function Layout({ children }) {
  return (
    <>
      <div className="page_wrapper" id="main-page-content">
        <Header />
        {children}
        <div className="purple_backdrop"></div>
        <Footer />
      </div>

    </>
  );
}
